import { ButtonSize } from "@gravity-ui/uikit";

export const MINIMAL_INNER_WIDTH = 594;
export const CUSTOM_SIZES = (isMaximized: boolean) => {
  return {
    elementWidth: isMaximized ? 185 : 50,
    button: (isMaximized ? "l" : "xs") as ButtonSize,
    icon: isMaximized ? 18 : 15,
  };
};
